import { Avatar, Button } from "@mantine/core";
import styled from "styled-components";

// `loading` sırasında Mantine butonu kendisi devre dışı bırakır — çift gönderimi
// engellemek için kaydetme akışlarında kullanılır.
const PageHeaderButton = ({ title, onClick, icon, disabled, loading }: any) => {
  return (
    <>
      <StyledButton
        leftSection={icon}
        loading={loading}
        disabled={disabled || loading}
        radius="10px"
        onClick={onClick}
        color={"#5C26FF"}
        style={{
          width: "max-content",
          height: "44px",
        }}
      >
        <ButtonLabel>{title}</ButtonLabel>
      </StyledButton>
    </>
  );
};
export default PageHeaderButton;

const ButtonLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
`;

const StyledButton = styled(Button)<any>`
  &[data-disabled="true"] {
    background-color: #e0d4fc;
  }
`;
